import React, {useState,  useEffect } from 'react';
import DeckGL from 'deck.gl';

import { renderLayers } from "./RenderLayers";
import TripBuilder from './trip-builder';


import {
    LightingEffect,
    AmbientLight,
    _SunLight as SunLight
} from "@deck.gl/core";


// 初期ビューポートの設定
const INITIAL_VIEW_STATE = {
    longitude: 139.7574157,
    latitude: 35.6826533,
    zoom: 17,
    maxZoom: 16,
    pitch: 65,
    bearing: 0
};

const ambientLight = new AmbientLight({
    color: [255, 255, 255],
    intensity: 1.5
});

const dirLight = new SunLight({
    timestamp: Date.UTC(2023, 11, 12, 10),
    color: [255, 255, 255],
    intensity: 30.0,
});


function startAnimation(data, callback) {
    if(!data) return null;
    const trips = data.map(waypoints => new TripBuilder({ waypoints, loop: true, speed:100 }));
    let timestamp = 0;
    let animation = null;

    const onAnimationFrame = () => {
        timestamp += 0.02;

        const frame = trips.map(trip => trip.getFrame(timestamp));
        /* frame
        longitude: frame[0].point[0],
        latitude: frame[0].point[1],
        bearing: frame[0].heading,
        */
        callback(frame)
        animation = requestAnimationFrame(onAnimationFrame);
    };
    onAnimationFrame();

    return () => cancelAnimationFrame(animation);
}



function Map() {

    const [data, setData] = useState(null);
    const [trackFrame, setTrackFrame] = useState([]);
    const [viwState, setViewState] = useState(INITIAL_VIEW_STATE);


    const [effects] = useState(() => {
        const lightingEffect = new LightingEffect({ dirLight });
        lightingEffect.shadowColor = [0, 0, 0, 0.5];
        return [lightingEffect];
    });


    useEffect(()=>{
        const loadData = async () =>{
            const resp = await fetch("./data/tokyo.json")
            const rjson = await resp.json(); 
            setData(rjson);
        }

        loadData();


    },[])

    useEffect(()=>{
        if(!data) return ;
        
        const stopAnimation = startAnimation(data, (frame)=>{
            //console.log(frame)

            setTrackFrame(frame);

            
            if (navigation) {
                setViewState(v => {
                    return {
                        ...v,
                        latitude: frame[0].point[1],
                        longitude: frame[0].point[0],
                        bearing: frame[0].heading,
                    }
                })

            }
            
        });
        

    }, [data, navigation])

    return (
        <div>
            <DeckGL
                effects={effects}
                viewState={viwState}
                controller={true}
                layers={renderLayers({ trackFrame })}
            >
            </DeckGL>
            <div className="attribution">
                <a
                    href="https://www.geospatial.jp/ckan/dataset/plateau-tokyo23ku-citygml-2020"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    ©indigo-lab
                </a>
                <a
                    style={{marginLeft:"1em"}}
                    href="https://www.mapbox.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    ©mapbox
                </a>
            </div>
        </div>
    );
}

export default Map;


